<template>
  <v-app-bar :clipped-left="false" fixed app>
    <div class="menu-logo">
      <img height="45x" alt="Skala Logo" :src="require('../../assets/img/big-logo.png')" />
    </div>

    <v-toolbar-title class="ml-6" v-text="title" />
    <v-spacer />

    <UserMenu />
  </v-app-bar>
</template>

<script>
import UserMenu from "./UserMenu";
export default {
  props: ["headTitle"],
  components: {
    UserMenu,
  },
  data() {
    return {
      titleMap: {
        AppIndex: "",
        Suppliers: this.$t("menu.supplier"),
        Customers: this.$t("menu.customer"),
        Products: this.$t("menu.products"),
        Stock: this.$t("menu.stock"),
        Factory: this.$t("menu.factory"),
      },
    };
  },
  computed: {
    title() {
      if (this.headTitle) {
        return this.titleMap[this.headTitle];
      } else return "";
    },
  },
};
</script>

<style scoped>
.menu-logo {
  margin: 17px 0 0 10px;
}
</style>